import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {AppService} from '../../app.service';

@Component({
  selector: 'app-recentchanges',
  templateUrl: './recentchanges.component.html',
  styleUrls: ['./recentchanges.component.scss']
})
export class RecentchangesComponent implements OnInit {

  appId;
  appIdChange: number;
  redirectionMethod: string;
  recentChangesData: any;

  constructor(
    private _route: ActivatedRoute,
    private _appService: AppService
  ) { }

  ngOnInit() {
    const appId = this._route.snapshot.params.appid;
    this.appIdChange = appId;

    this._route.params.forEach((params: any) => {
      console.log(params['appid']);
      const redirection = params['redirection'];
      if (redirection !== '') {
        this.redirectionMethod = redirection;
      } else {
        this.redirectionMethod = '';
      }
    });

    this._appService.getVersionData(appId).subscribe(res => {
      console.log(res);
      this.recentChangesData = res;
    });

  }

}
